import type { AxiosRequestConfig } from 'axios';
import { TaskCollection } from '../models';
import { ModelResource } from './resource';
import type { PaginatedResult } from './resource';

const collectByTransform = {
  classifications_any: 'classification',
  classifications_eq: 'classification',
};

const VALID_GROUP_BY = new Set(['partner', 'task_type', 'classification', 'expected_action']);

const FRONTEND_ONLY_KEYS = new Set([
  'group_view_mode',
  'group_view_id',
  'collection_type',
  'collection_id',
  'sub_collection_type',
  'sub_collection_id',
  'task_drawer_id',
  'task_display_mode',
]);

const sanitizeParams = (params: Record<string, any>): Record<string, any> => {
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(([k]) => !FRONTEND_ONLY_KEYS.has(k)),
  );

  if (cleaned.group_by && !VALID_GROUP_BY.has(cleaned.group_by)) {
    delete cleaned.group_by;
  }

  return cleaned;
};

export class TaskCollections extends ModelResource<TaskCollection> {
  model = TaskCollection;

  resourcePath = 'v1/tasks/collections';

  override async list(
    args?: AxiosRequestConfig,
    paginatedResult?: false,
  ): Promise<TaskCollection[]>;
  override async list(
    args?: AxiosRequestConfig,
    paginatedResult?: true,
  ): Promise<PaginatedResult<TaskCollection>>;
  override async list(
    args?: AxiosRequestConfig,
    paginatedResult?: boolean,
  ): Promise<TaskCollection[] | PaginatedResult<TaskCollection>> {
    if (args?.params) {
      args = { ...args, params: sanitizeParams(args.params) };
    }

    return super.list(args, paginatedResult as any);
  }

  listGroupBy(collectBy?: string, args?: Record<string, any>): Promise<TaskCollection[]>;
  listGroupBy(
    collectBy: string,
    args: Record<string, any>,
    pagination: true,
  ): Promise<PaginatedResult<TaskCollection>>;
  listGroupBy(collectBy?: string, args?: Record<string, any>, pagination?: boolean) {
    const groupBy = (collectByTransform[collectBy || ''] as string) || collectBy;
    const query = args?.query || {};

    if (pagination) {
      return this.list(
        {
          params: {
            group_by: groupBy,
            ...query,
          },
        },
        true,
      );
    } else {
      return this.list(
        {
          params: {
            group_by: groupBy,
            ...query,
          },
        },
        false,
      );
    }
  }
}
